import { EntityState } from "@ngrx/entity";

import { StoryEntity, StoryEditEntity } from '../entities';
import { GetStoriesInputApiModel, SearchStoryInputApiModel } from "@modules/story/models/api-models/input";
import { StoryFacetedSearchModel } from "../models";

export interface StoryState extends EntityState<StoryEntity> {
    loading: boolean;
    loaded: boolean;
    prevUrl: string;
    nextUrl: string;
    total: number;
    creating: boolean;
    updating: boolean;
    selectedStoryIdOrSlug: number | string;
    storyEditData: StoryEditEntity;
    queryStoriesData: GetStoriesInputApiModel | SearchStoryInputApiModel;
    isEmbedMode: boolean;
    facetedSearchResult: StoryFacetedSearchModel;
    frequent_tags?:any
}